import type { IconFieldDesignTokens, IconFieldTokenSections } from '@primeuix/themes/types/iconfield';

export const icon: IconFieldTokenSections.Icon = {
    color: '{form.field.icon.color}'
};

export const css: IconFieldTokenSections.CSS = /*css*/ ``;

export default {
    icon,
    css
} satisfies IconFieldDesignTokens;
